import Svg, { G, Mask, Path } from 'react-native-svg'
const BizzLogo = ({ color = '#0F3CC9' }) => (
  <Svg xmlns="http://www.w3.org/2000/svg" width={56} height={56} fill="none">
    <Mask
      id="a"
      width={56}
      height={56}
      x={0}
      y={0}
      maskUnits="userSpaceOnUse"
      style={{
        maskType: 'luminance',
      }}>
      <Path fill="#fff" d="M56 0H0v56h56V0Z" />
    </Mask>
    <G mask="url(#a)">
      <Path fill={color} d="M56.004 28a28 28 0 1 1-56 0 28 28 0 0 1 56 0Z" />
      <Path
        fill="#fff"
        d="M26.134 45.95a5.35 5.35 0 0 1-1.334-.532l-2.4-1.386v-6.217a1.867 1.867 0 0 0-3.733 0v4.063l-4.15-2.395a7.086 7.086 0 0 1-3.202-5.546V22.065a7.088 7.088 0 0 1 3.202-5.546L24.8 10.58a6.503 6.503 0 0 1 3.204-.759 6.506 6.506 0 0 1 3.202.762l10.282 5.939a7.085 7.085 0 0 1 3.202 5.546v11.87a7.086 7.086 0 0 1-3.202 5.544l-4.15 2.395V24.518a1.867 1.867 0 1 0-3.734 0v19.516l-2.398 1.384a5.36 5.36 0 0 1-1.334.532V31.194a1.867 1.867 0 0 0-3.734 0V45.95h-.003Z"
      />
    </G>
  </Svg>
)
export default BizzLogo
